const initialState = {
    responseHeaderList: {},
    responseHeader: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "HEADER_LIST_RESPONSE":
            newState.responseHeaderList = action.value
            break;
        case "HEADER_RESPONSE":
            newState.responseHeader = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;